var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3H16.5V21H7.5V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3H8.25V21H3.75C2.094 21 0.75 19.656 0.75 18V6C0.75 4.344 2.094 3 3.75 3Z",
    fill: "#092050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21H15.75L15.75 3H20.25C21.906 3 23.25 4.344 23.25 6L23.25 18C23.25 19.656 21.906 21 20.25 21Z",
    fill: "#BE2A2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.25 3H3.75C2.09325 3 0.75 4.34325 0.75 6V18C0.75 19.6567 2.09325 21 3.75 21H20.25C21.9067 21 23.25 19.6567 23.25 18V6C23.25 4.34325 21.9067 3 20.25 3ZM22.5 18C22.5 19.2405 21.4905 20.25 20.25 20.25H3.75C2.5095 20.25 1.5 19.2405 1.5 18V6C1.5 4.7595 2.5095 3.75 3.75 3.75H20.25C21.4905 3.75 22.5 4.7595 22.5 6V18Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.25 3.75H3.75C2.50725 3.75 1.5 4.75725 1.5 6V6.75C1.5 5.50725 2.50725 4.5 3.75 4.5H20.25C21.4928 4.5 22.5 5.50725 22.5 6.75V6C22.5 4.75725 21.4928 3.75 20.25 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.86b57fa3db5742fc8fdaabeabc4f1d60.svg";
export { ForwardRef as ReactComponent };